import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import subscriptionOptions from '../utils/subscriptionOptions';
import Tooltip from 'flarum/common/components/Tooltip';
import extractText from 'flarum/common/utils/extractText';
import Stream from 'flarum/common/utils/Stream';
export default class SubscriptionStateButton extends Button {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", void 0);
    _defineProperty(this, "canShowTooltip", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = Stream(false);
    this.canShowTooltip = Stream(false);
  }
  onbeforeupdate(vnode) {
    var _app$session$user;
    super.onbeforeupdate(vnode);
    const subscription = this.attrs.subscription || false;
    const preferences = (_app$session$user = app.session.user) == null ? void 0 : _app$session$user.preferences();
    const notifyEmail = preferences == null ? void 0 : preferences['notify_newPostInTag_email'];
    const notifyAlert = preferences == null ? void 0 : preferences['notify_newPostInTag_alert'];
    if ((notifyEmail || notifyAlert) && subscription === false) {
      this.canShowTooltip(undefined);
    } else {
      this.canShowTooltip(false);
    }
  }
  view(vnode) {
    var _app$session$user2;
    const subscription = this.attrs.subscription || false;
    const option = subscriptionOptions.find(opt => opt.subscription === subscription);
    const buttonIcon = option ? option.icon : 'fas fa-star';
    const buttonLabel = option ? app.translator.trans(option.labelKey) : app.translator.trans('fof-follow-tags.forum.sub_controls.follow_button');
    this.attrs.className = (this.attrs.className || '') + ' SubscriptionButton ' + 'SubscriptionButton--' + subscription;
    this.attrs.icon = buttonIcon;
    const preferences = (_app$session$user2 = app.session.user) == null ? void 0 : _app$session$user2.preferences();
    const notifyEmail = preferences == null ? void 0 : preferences['notify_newPostInTag_email'];
    const tooltipText = extractText(app.translator.trans(notifyEmail ? 'fof-follow-tags.forum.sub_controls.notify_email_tooltip' : 'fof-follow-tags.forum.sub_controls.notify_alert_tooltip'));
    return m(Tooltip, {
      text:
      // By adding this constraint we make sure that when we explicitly set the
      // value of `canShowTooltip` to `false`, the internal `shouldRecreateTooltip`
      // property of the `Tooltip` component is set to `true` and we can, in that
      // way, switch between 'manual' and 'hover' trigger modes for the tooltip.
      typeof this.canShowTooltip() === 'boolean' ? '' : tooltipText,
      tooltipVisible: this.canShowTooltip(),
      position: this.attrs.tooltipPosition || 'bottom',
      delay: 250
    }, super.view(Object.assign({}, vnode, {
      children: buttonLabel
    })));
  }
}
flarum.reg.add('fof-follow-tags', 'forum/components/SubscriptionStateButton', SubscriptionStateButton);